// Pure collision-avoidance lift algorithm for the Requests capture trigger
// (franklycatering #497), extracted so the whole skip-own-nodes ->
// walk-up -> bar-heuristic -> arithmetic path is unit-testable under jsdom
// (which implements neither elementsFromPoint nor layout).

export interface LiftDeps {
  getStyle: (el: Element) => { position: string };
  getRect: (el: Element) => { top: number; height: number };
}

/** `stack` is an elementsFromPoint result, topmost-first. Returns px to lift by. */
export function computeLift(
  stack: readonly Element[],
  innerHeight: number,
  deps: LiftDeps = {
    getStyle: (el) => getComputedStyle(el),
    getRect: (el) => el.getBoundingClientRect(),
  },
): number {
  const under = stack.find((n) => !n.closest("[data-requests]"));
  if (!under) return 0;
  for (let node: Element | null = under; node && node !== document.body; node = node.parentElement) {
    if (deps.getStyle(node).position !== "fixed") continue;
    const rect = deps.getRect(node);
    const isBar = rect.height < innerHeight * 0.6; // bar, not a full-height overlay
    return isBar ? Math.max(0, Math.round(innerHeight - rect.top + 8)) : 0;
  }
  return 0;
}
